export interface ConsistencyCheckResult {
    isDataConsistent: boolean;
    warnings: string[];
}
